import { useSelector } from 'umi';
import type { TDragCard } from '@/types/common/index';

export default function useGetDragInfo(): TDragCard {
  return useSelector<{ drag: TDragCard }, TDragCard>((state: any) => {
    return state.drag;
  });
}
